import React from 'react';
import { bool, shape, string } from 'prop-types';

const ArrowBackColor = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 8.25H5.8725L10.065 4.0575L9 3L3 9L9 15L10.0575 13.9425L5.8725 9.75H15V8.25Z" fill="currentColor" />
  </svg>
);

ArrowBackColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default ArrowBackColor;
